<template>
    <div class="outline-container">
        <div class="column">
          <div class="row justify-between outline-header">
            <el-button type="primary" class="go-back" size="mini" @click.stop="modelChange(1)" plain>返回</el-button>
            <el-button-group>
              <el-button v-for="item in levelList"
                         :key="item.value"
                         :type="level === item.value ? 'primary' : ''"
                         size="mini"
                         @click.stop="levelClick(item.value)">{{ item.label }}</el-button>
            </el-button-group>
          </div>

            <!-- 大纲 -->
            <div class="summary-content">
                <div class="edit-desc text-center">编辑大纲，生成全文</div>
                <p class="edit-desc-content">
                    <i style="color: #e1a200" class="el-icon-message-solid"></i>
                    大纲可<span class="label-1">直接修改</span>，
                    点击<i class="el-icon-edit label-2 cursor-pointer"></i>可以对标题进行<span class="label-1">编辑</span>，
                    点击<i class="el-icon-delete label-2 cursor-pointer"></i>可对大纲章节进行<span class="label-1">删除</span>，
                    点击<img class="desc-icon cursor-pointer" src="@/assets/images/icon-chart2.png"></img>可为本章节<span class="label-1">插入图表</span>，
                    点击<img class="desc-icon cursor-pointer" src="@/assets/images/icon-table2.png"></img>可为本章节<span class="label-1">插入数据表格</span>，
                    点击<img class="desc-icon cursor-pointer" src="@/assets/images/icon-code2.png"></img>可为本章节<span class="label-1">插入代码</span>。
                </p>

                <SummaryTyping v-if="summaryList.length" ref="summary-typing" :topic="formTopic"></SummaryTyping>
            </div>
            <div v-if="!summaryList.length" class="col column justify-center items-center cursor-pointer empty-summary">
                <div @click.stop="focusTopic">
                    <img src="@/assets/images/empty-paper.png" />
                </div>
                <div @click.stop="focusTopic" class="empty-text">输入文章标题生成大纲</div>
            </div>

            <div class="text-center paper-submit-btn">
                <el-button class="generate-btn" size="large" type="primary" @click.stop="generatePaper()" :disabled="!summaryList.length">点击生成文章</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import SummaryTyping from './summary-typing.vue'
export default {
    props: {
        level: { // 大纲级别
          type: String,
          default: ''
        },
        levelChange: { // 修改大纲级别
          type: Function,
          required: true
        },
        formTopic: {
            type: String,
            default: ''
        },
        summaryList: { // 大纲列表
            type: Array,
            default: () => []
        },
        generatePaper: { // 生成论文
            type: Function,
            required: true
        }
    },
    components: {
        SummaryTyping
    },
    data () {
        return {
          levelList: [
            { label: '二级大纲', value: '二级' },
            { label: '三级大纲', value: '三级' }
          ]
        }
    },
    watch: {
        summaryList: {
            deep: true,
            immediate: true,
            handler (val) {
                if (val && val.length) {
                    this.getSummary()
                }
            }
        }
    },
    inject: ['modelChange', 'showSummary'],
    methods: {
        focusTopic () { // 切换到条件编辑页面
            this.modelChange(1)
        },
        getSummary () { // 生成大纲
            this.$nextTick(() => {
                this.$refs['summary-typing'] && this.$refs['summary-typing'].triggerTyping(this.summaryList)
            })
        },
        getSummaryContent () {
            return this.$refs['summary-typing'].titleList
        },
        levelClick (level) { // 大纲级别切换
          if (this.level === level) return

          // 携带大纲级别参数，重新查询大纲
          this.levelChange(level)
          this.showSummary()
        }
    }
}
</script>

<style lang="less" scoped>
.outline-container {
    height: 100%;
    box-sizing: border-box;
    padding: 0 80px;
    overflow: auto;
    .outline-header {
      padding: 10px 12px;
      .go-back {
          width: 60px;
          .back-icon {
              font-size: 16px;
          }
      }
    }

    .empty-text {
        color: #8d8d8d;
        font-size: 16px;
        margin-top: 20px;
    }

    .generate-btn {
        width: 260px;
    }

    .summary-content {
        margin-top: 30px;
        .edit-desc {
            color: #3680F9;
            font-size: 22px;
            font-weight: 700;
        }
        .edit-desc-content {
            padding: 0 12px;
            text-indent: 1em;
            font-size: 14px;
            margin-top: 30px;
            line-height: 30px;
            .label-1 {
                color: #f0a020;
            }
            .label-2 {
                color: #4a4a4a;
                font-size: 20px;
                margin-left: -6px;
                margin-right: 6px;
            }
            .desc-icon {
                width: 34px;
                height: 34px;
                vertical-align: bottom;
            }
        }
    }
    .empty-summary {
        margin-top: 70px;
    }

    .paper-submit-btn {
        padding: 0 12px;
        margin-top: 20px;
    }
}
@media screen and (max-width: 900px) {
    .outline-container {
        padding: 0;
        .summary-content {
            margin-top: 10px;
            .edit-desc-content {
                display: none;
            }
        }
    }
}
</style>
